export const SR_OPENAI_ASSISTANT_NAME_CONVO_SUMMARIZER = 'convoSummarizer';
